import { messaging } from '../firebase-config/index';
import { getToken } from 'firebase/messaging';

const API_URL = process.env.REACT_APP_API_URL;
const VAPIDKEY = process.env.VAPIDKEY;
const firebaseMessagingEnabled = Boolean(messaging);

// Helper function to handle the response from fetch calls
async function handleResponse(response) {
    if (!response.ok) {
        const errorData = await response.json();
        return { error: true, message: errorData.message || 'Network error' };
    }
    return { error: false, data: await response.json() };
}

// Generic fetch function
async function fetchData(url, options = {}) {
    try {
        const response = await fetch(url, options);
        return await handleResponse(response);
    } catch (error) {
        return { error: true, message: error.message };
    }
}

export async function add_notifications(token) {
    if (!firebaseMessagingEnabled) {
        console.warn('Firebase messaging is disabled for now.');
        return true;
    }
    try {
        const permission = await Notification.requestPermission();
        if (permission === 'granted') {
            const notify_token = await getToken(messaging, { vapidKey: VAPIDKEY });
            const options = {
                method: "POST",
                headers: {
                    'Authorization': `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(notify_token),
            };
            return fetchData(`${API_URL}/notification/add`, options);
        } else {
        console.log('Unable to get permission to notify.');
        }
    } catch (error) {
        console.error('Error getting permission', error);
        return false
    }
    return true;
}

export async function delete_notifications(token) {
    if (!firebaseMessagingEnabled) {
        console.warn('Firebase messaging is disabled; nothing to delete.');
        return true;
    }
    try {
        const notify_token = await getToken(messaging, { vapidKey: VAPIDKEY });
        const options = {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(notify_token),
        };
        return fetchData(`${API_URL}/notification/delete`, options);
    } catch (error) {
        return false
    }
}
